import gql from 'graphql-tag';

const MESSAGE_FRAGMENT = gql`
  fragment MessageFragment on Message {
    _id
    from {
      _id
      first
      last
      avatar
    }
    body
    attachment {
      type
      payload
      contentType
      filename
    }
    createdAt {
      timestamp
    }
  }
`;

const SUPPORT_POOL_FRAGMENT = gql`
  fragment SupportPoolFragment on SupportPool {
    _id
    user {
      _id
      first
      last
      avatar
      lastLoginType
      email
      phone
      device
      tutor {
        _id
        organization {
          _id
          name
        }
        universities {
          _id
          name
        }
      }
      student {
        _id
        organization {
          _id
          name
        }
        university {
          _id
          name
        }
      }
    }
    state
    admin {
      _id
    }
    organization {
      name
      _id
    }
    lastMessage {
      _id
      body
      createdAt {
        timestamp
      }
      attachment {
        type
      }
    }
  }
`;

export const FETCH_CUSTOMER_SUPPORT_POOLS_QUERY = gql`
  {
    adminSupportPools {
      ...SupportPoolFragment
    }
  }
  ${SUPPORT_POOL_FRAGMENT}
`;

export const FETCH_CUSTOMER_SUPPORT_MESSAGES_QUERY = gql`
  query adminCustomerSupportMessages($supportPool: ID!, $page: PaginationInput!) {
    adminCustomerSupportMessages(_supportPool: $supportPool, page: $page) {
      ...MessageFragment
    }
  }
  ${MESSAGE_FRAGMENT}
`;

export const SEND_MESSAGE_MUTATION = gql`
  mutation addCustomerSupportMessage($customerSupportInput: CustomerSupportInput!) {
    addCustomerSupportMessage(input: $customerSupportInput) {
      _id
    }
  }
`;

export const SUBSCRIBE_TO_MESSAGES_SUBSCRIPTION = gql`
  subscription customerSupportAdded($supportPool: ID!, $user: ID!) {
    customerSupportAdded(_supportPool: $supportPool, _user: $user) {
      _id
      _support_pool
      _from
      body
      createdAt {
        timestamp
      }
    }
  }
`;

export const ACCEPT_SUPPORT_MUTATION = gql`
  mutation acceptSupport($supportPool: ID!) {
    acceptCustomerSupport(_supportPool: $supportPool) {
      ...SupportPoolFragment
    }
  }
  ${SUPPORT_POOL_FRAGMENT}
`;

export const RESOLVE_SUPPORT_MUTATION = gql`
  mutation resolveSupport($supportPool: ID!) {
    resolveCustomerSupport(_supportPool: $supportPool) {
      ...SupportPoolFragment
    }
  }
  ${SUPPORT_POOL_FRAGMENT}
`;

export const UNRESOLVE_SUPPORT_MUTATION = gql`
  mutation unresolveSupport($supportPool: ID!) {
    unresolveCustomerSupport(_supportPool: $supportPool) {
      ...SupportPoolFragment
    }
  }
  ${SUPPORT_POOL_FRAGMENT}
`;



// WEBPACK FOOTER //
// ./src/modules/messages/api.js